import { type ConfirmationDialogSettings } from "@/components/basics/DialogConfirmation.vue";
import { type FullscreenGallery_Config } from "@/services/images";
import { type ItemParameterChangeDataWrapper } from "@/types";

export enum Event {
  ShowTextOverlay,
  HideTextOverlay,

  ToastSuccess,
  ToastError,
  OpenGallery,

  PortfolioItemHardRemoved,
  CollectionParamsChanged,
  CollectionParamsSynchronize,

  DropdownOpen,
  Confirm,

  OpenAuthDialog,
  OpenAddItemDialog,

  OpenCookieConsent,
}

export type EmitConfig =
  // Events with NO additional data expected
  | {
      event: Event.HideTextOverlay | Event.PortfolioItemHardRemoved | Event.CollectionParamsSynchronize | Event.OpenAuthDialog | Event.OpenAddItemDialog | Event.OpenCookieConsent;
    }
  // Events WITH some additional data expected
  | {
      event: Event.ShowTextOverlay;
      data: string; // msg
    }
  | {
      event: Event.ToastError | Event.ToastSuccess;
      data: string; // msg
    }
  | {
      event: Event.OpenGallery;
      data: FullscreenGallery_Config;
    }
  | {
      event: Event.CollectionParamsChanged;
      data: ItemParameterChangeDataWrapper;
    }
  | {
      event: Event.DropdownOpen;
      data: number | null; // componentId @deprecated
    }
  | {
      event: Event.Confirm;
      data: ConfirmationDialogSettings;
    };

export const EventBus = {
  listeners: new Map<Event, CallableFunction[]>(),

  on: function (event: Event, fn: CallableFunction) {
    if (!this.listeners.get(event)) {
      this.listeners.set(event, []);
    }

    this.listeners.get(event)?.push(fn);
  },

  off: function (event: Event, fn?: CallableFunction) {
    const thisEventlisteners = this.listeners.get(event);
    if (thisEventlisteners !== undefined) {
      if (fn) {
        for (let i = 0; i < thisEventlisteners.length; i++) {
          if (thisEventlisteners[i] === fn) {
            thisEventlisteners.splice(i, 1);
            break;
          }
        }
      } else {
        this.listeners.set(event, []); // off all
      }
    }
  },

  emit: function (emitConfig: EmitConfig) {
    const listeners = this.listeners.get(emitConfig.event);
    if (listeners) {
      listeners.forEach(function (fn: CallableFunction) {
        if ("data" in emitConfig) {
          fn(emitConfig.data);
        } else {
          fn();
        }
      });
    }
  },
};
